export enum PatientOperation {
    CREATE = 'operation.entity.patient.create',
    EDIT = 'operation.entity.patient.edit',
    ATTACH = 'operation.entity.patient.attach',
    MERGE = 'operation.entity.patient.merge',
    DELETE = 'operation.entity.patient.delete'
}
